/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeClockPopupauditCtrl
 */
angular.module('mercury.modules.time.clock')
.controller('TimeClockPopupauditCtrl', ["clockinId", "$resource", "$scope", "userinfo", "settings", function(clockinId, $resource, $scope, userinfo, settings) {
  var ClockinHistory = $resource(settings.mercHost + '/time/clockins/histories');

  $scope.clocksHistory = ClockinHistory.query({'$filter': 'ClockinId eq ' + clockinId});
  /**
   * Return a human readable description of a ClockinHistory record
   */
  $scope.describeHistory = function(history) {
    if (history.operation != 'Updated') {
      return 'Clock ' + history.operation.toLowerCase();
    }

    var changedColumns = [];
    if (history.clockinTimeUpdated) {
      changedColumns.push('Clock in set to ' + moment(history.clockinTime).format('h:mma, DD MMM YYYY'));
    }

    if (history.clockoutTimeUpdated) {
      changedColumns.push('Clock out set to ' + moment(history.clockoutTime).format('h:mma, DD MMM YYYY'));
    }

    if (history.roleUpdated) {
      changedColumns.push('Role set to ' + history.roleName);
    }

    if (history.hourlyRateUpdated) {
      if (userinfo.companyHasPermission('Payroll')) {
        changedColumns.push('Hourly rate set to $' + parseFloat(history.hourlyRate).toFixed(2));
      } else {
        changedColumns.push('Hourly rate updated');
      }
    }

    if (history.ruleIdUpdated) {
      changedColumns.push('Payrate Adjustment set to ' + (history.ruleName || 'Ordinary Time'));
    }

    return changedColumns.join(', ');
  };
}]);
